import type {
    TimeSeriesItem,
    TimeSeriesPoint,
} from "~/modules/asset_timeseries_v4/types";

// // // //

export function getAverageSeries(
    data: TimeSeriesItem[],
    name: string,
    color: string,
): TimeSeriesItem | null {
    const firstItem = data[0];
    if (!firstItem) {
        return null;
    }

    const valuesByDate = new Map<string, number[]>();
    for (const item of data) {
        for (const [date, rawValue] of item.points) {
            const value = Number(rawValue);
            if (!Number.isFinite(value)) {
                continue;
            }

            const values = valuesByDate.get(date) ?? [];
            values.push(value);
            valuesByDate.set(date, values);
        }
    }

    const points: TimeSeriesPoint[] = Array.from(valuesByDate.entries())
        .sort(([leftDate], [rightDate]) => leftDate.localeCompare(rightDate))
        .map(([date, values]) => [
            date,
            values.reduce((total, value) => total + value, 0) / values.length,
        ]);

    return {
        measure: firstItem.measure,
        group: {
            id: -1,
            type: "average",
            name,
            slug: name,
            color,
        },
        points,
    };
}
